import React,{useState,useEffect} from "react";
import "./TermsAndConditions.css";
import { Link } from "react-router-dom";
const RolesResponsibilities = () => {
   const [isVisible, setIsVisible] = useState(false);
        
          // Show button only after scrolling 200px
          useEffect(() => {
            const toggleVisibility = () => {
              if (window.scrollY > 200) {
                setIsVisible(true);
              } else {
                setIsVisible(false);
              }
            };
        
            window.addEventListener("scroll", toggleVisibility);
            return () => window.removeEventListener("scroll", toggleVisibility);
          }, []);
        
          const scrollToTop = () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          };

  return (
    <div className="page-body">
      <div className="terms-container">
      {/* <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h5 className="page-title mt-3"><strong>Roles & Responsibilities of NPCI, PSB & TPAP</strong></h5>
          <div className="breadcrumb m-0 text-end">
            <Link to="/compliance-center">Compliance Center</Link>&nbsp;&gt;&nbsp;
            <strong>Roles & Responsibilities of NPCI, PSB & TPAP</strong>
          </div>
        </div> */}

      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
       <h5 className="page-title mt-3">
         <p style={{fontWeight:"600"}}>Roles & Responsibilities of NPCI, PSB & TPAP</p>
       </h5>
     <div className="breadcrumb m-0 text-end">
       <Link to="/" className="breadcrumb-link">
         Home
       </Link>
       &nbsp;&gt;&nbsp;
       <Link to="/compliance-center" className="breadcrumb-link">
         Compliance Center
       </Link>
       &nbsp;&gt;&nbsp;
       <span className="breadcrumb-current">Roles & Responsibilities of NPCI, PSB & TPAP</span>
     </div>
     
     </div>

        <ol>
          <li>NPCI owns and operates the Unified Payments Interface (UPI) platform</li>
          <li>NPCI prescribes rules, regulations, guidelines, and the respective roles, responsibilities and liabilities of the participants, with respect to UPI...</li>
          <li>NPCI approves the participation of Issuer Banks, PSP Banks, Third Party Application Providers (TPAP)...</li>
          <li>NPCI provides a safe, secure and efficient UPI system and network</li>
          <li>NPCI provides online transaction routing, processing and settlement services to members participating in UPI</li>
          <li>NPCI can, either directly or through a third party, conduct audit on UPI participants...</li>
          <li>NPCI provides the banks participating in UPI access to system where they can download reports...</li>
        </ol>

        <h5 className="vc_custom_heading"><strong>Roles & responsibilities of PSP Bank</strong></h5>
        <ol>
          <li>PSP Bank is a member of UPI and connects to the UPI platform for availing UPI payment facility...</li>
          <li>PSP Bank, either through its own app or TPAP’s app, on-boards and registers the end-user customers...</li>
          <li>PSP Bank is responsible for authentication of the end-user customer at registration...</li>
          <li>PSP Bank engages and on-boards the TPAPs to make the TPAP’s UPI app available...</li>
          <li>PSP Bank has to ensure that TPAP and its systems are adequately secure...</li>
          <li>PSP Bank is responsible to ensure that UPI app and systems of TPAP are audited...</li>
          <li>PSP Bank has to store all the payments data including UPI Transaction Data only in India</li>
          <li>PSP Bank is responsible to give UPI customers the option to choose any bank account...</li>
          <li>PSP Bank is responsible to put in place a grievance redressal mechanism...</li>
        </ol>

        <h5 className="vc_custom_heading"><strong>Roles & responsibilities of TPAP</strong></h5>
        <ol>
          <li>TPAP is a service provider and participates in UPI through PSP Bank</li>
          <li>TPAP is responsible to comply with all the requirements prescribed by PSP Bank and NPCI...</li>
          <li>TPAP is responsible to ensure that its systems are adequately secure to function...</li>
          <li>TPAP is responsible to comply with all applicable laws, rules, regulations, guidelines...</li>
          <li>TPAP has to store all the payments data including UPI Transaction Data only in India</li>
          <li>TPAP is responsible to facilitate RBI, NPCI and other agencies to access data and audit...</li>
          <li>TPAP shall facilitate the end-user customer with an option to raise grievance...</li>
        </ol>

      {/* Add Button (aligned to left) */}
 {isVisible && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            <i className="bi bi-chevron-up"></i>
          </button>
        )}


      </div>
    </div>
  );
};

export default RolesResponsibilities;
